export const ARTICLE_ID_QUERY_PARAM_KEY = "ar_id"
export const TOPIC_ID_QUERY_PARAM_KEY = "tc_id"
export const SUBTOPIC_ID_QUERY_PARAM_KEY = "st_id"
